import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';
export function IngredientCategories() {
  return <section className="py-20 bg-white" data-id="element-1858" data-mp="j9zotwkbag00">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1859" data-mp="jd5fvhci3ryd">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1860" data-mp="5j4lezsl0r3t">
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-1861" data-mp="9kzni6ic78in">
            Understanding Ingredient Categories
          </h2>
          <p className="text-lg text-slate-600" data-id="element-1862" data-mp="3rpjg4q1f9ocf">
            To make scanning as intuitive as possible, IntelliEats sorts every
            detected ingredient into three simple, color-coded categories.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-1863" data-mp="3issmsle98nlj">
          <div className="bg-green-50 rounded-2xl p-8 border border-green-100" data-id="element-1864" data-mp="3mssza0hsmopy">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-1865" data-mp="1gytb3yx8048b">
              <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-1866" data-mp="1l0y02kcq4com" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1867" data-mp="2cnx6glwulcaq">
              Safe Ingredients
            </h3>
            <p className="text-slate-700 leading-relaxed" data-id="element-1868" data-mp="27q411v3dcmbi">
              Marked in green, these are generally recognized as safe (GRAS) by
              food authorities. They include whole foods, natural spices,
              standard vitamins, and benign additives like citric acid. When you
              see a list full of green, you can feel confident that the product
              is made from recognizable, non-toxic components.
            </p>
          </div>
          <div className="bg-yellow-50 rounded-2xl p-8 border border-yellow-100" data-id="element-1869" data-mp="23nqy1eg0b2if">
            <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mb-6" data-id="element-1870" data-mp="23le5k7cmh9r4">
              <AlertTriangle className="w-6 h-6 text-yellow-600" data-id="element-1871" data-mp="1yr0h6owdo2vy" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1872" data-mp="3f50gbxnefoi5">
              Limited Intake
            </h3>
            <p className="text-slate-700 leading-relaxed" data-id="element-1873" data-mp="3a65k9u0f83g3">
              Marked in amber, these ingredients aren't strictly toxic, but they
              should be consumed in moderation. This category catches added
              sugars, excessive sodium, refined carbohydrates, and certain
              flavor enhancers like MSG. It serves as a gentle warning to
              balance this food with healthier choices throughout your day.
            </p>
          </div>
          <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-1874" data-mp="2yi2se79zjqvt">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-6" data-id="element-1875" data-mp="33gnvcegmgony">
              <XCircle className="w-6 h-6 text-red-600" data-id="element-1876" data-mp="38dxhnl8psk7k" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1877" data-mp="3d5xqk36ringa">
              Ingredients to Avoid
            </h3>
            <p className="text-slate-700 leading-relaxed" data-id="element-1878" data-mp="2foz12sk8pq4d">
              Marked in red, these are the red flags. This category includes
              artificial trans fats, controversial food dyes, chemical
              preservatives like sodium benzoate, and artificial sweeteners that
              have been linked to adverse health effects. If a product has
              multiple red ingredients, it's usually best to leave it on the
              shelf.
            </p>
          </div>
        </div>
      </div>
    </section>;
}